import React from "react";
import StudentSignup from "../Components/Signup/StudentSignup";
import TeacherSignup from "../Components/Signup/TeacherSignup";
import { Tabs, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function Signup() {
  const { t } = useTranslation(); // Assigner useTranslation à {t}

  return (
    <div>
      <Tabs
        variant="underline"
        defaultActiveKey="student"
        id="signup-tabs"
        className="justify-content-center"
      >
        <Tab eventKey="student" title={t("student_tab")} className="">
          <StudentSignup />
        </Tab>
        <Tab eventKey="teacher" title={t("teacher_tab")} className="">
          <TeacherSignup />
        </Tab>
      </Tabs>
    </div>
  );
}

export default Signup;
